<div
  class="actions"
  [ngClass]="{
    'full-width': stylingOptions().fullWidth,
    'reverse-buttons': stylingOptions().reverseButtons,
  }"
>
  @if (
    controller().value || (controller().errors && (controller().dirty || controller().touched))
  ) {
    <button
      type="button"
      mat-mini-fab
      [color]="stylingOptions().noBackground ? '' : 'warn'"
      (click)="removeFile()"
    >
      <mat-icon>delete</mat-icon>
    </button>
  }

  <button type="button" mat-raised-button (click)="fileInput.click()" color="primary">
    {{ uploadButtonText() ?? 'SHARED.UPLOAD_IMAGE' | translate }}
  </button>
</div>
<input
  #fileInput
  type="file"
  hidden
  (change)="handleUpload($event.target.files[0])"
  [accept]="'image/png,image/jpeg,image/gif,image/webp'"
/>

@if (controller().invalid && (controller().dirty || controller().touched)) {
  <mat-error>
    @if (controller().errors?.required) {
      {{ 'SHARED.VALIDATION.REQUIRED' | translate }}
    }
    @if (controller().errors?.size) {
      {{ 'SHARED.VALIDATION.SIZE' | translate: { size: limit() | formatBytes } }}
    }
    @if (controller().errors?.type) {
      {{ 'SHARED.VALIDATION.TYPE' | translate }}
    }
  </mat-error>
}
